// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2OHP_","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__OOds4"};